import { useState, useEffect } from "react";
import SideMenu from "../components/SideMenu";
import Header from "../components/Header";
import UserMenu from "../components/UserMenu";
import { useSelector } from "react-redux";
import axios from "axios";
import API_BASE_URL from "../utilities/ApiConfig";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import REPORT_BASE_URL from "../utilities/ReportConfig";

const Commision = () => {
  const [currentDate, setCurrentDate] = useState("");
  const [cashReceiptData, setCashReceiptData] = useState("");
  const [fromYear, setFromYear] = useState("");
  const [toYear, setToYear] = useState("");
  const [selectedYears, setSelectedYears] = useState(0);
  const [bookNo, setBookNo] = useState("");
  const [noOfCopies, setNoOfCopies] = useState("");
  const [fee, setFee] = useState("50");
  const [updateCashReceiptDetails, setUpdateCashReceiptData] = useState("");
  const [editMode, setEditMode] = useState(false);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [formData, setFormData] = useState({
    prtname: "",
    prt2name: "",
    property_detail: "",
  });
  const [validationErrors, setValidationErrors] = useState({
    prtname: false,
    prt2name: false,
    property_detail: false,
  });
  const location = useLocation();
  const { regYear, vol, sr, typeRecpt, mod } = location.state || {};
  console.log("updateCashReceiptDetails", updateCashReceiptDetails);
  console.log("cashReceiptData", cashReceiptData);

  const { userDetails } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  console.log("userDetails", userDetails.dcode);

  useEffect(() => {
    const today = new Date();
    const formattedDate = `${today.getDate()}/${
      today.getMonth() + 1
    }/${today.getFullYear()}`;
    setCurrentDate(formattedDate);
  }, []);

  const generateYears = () => {
    const currentYear = new Date().getFullYear();
    return Array.from({ length: currentYear - 1949 }, (_, i) => 1950 + i);
  };

  const handleChange = (e) => {
    debugger;
    const { id, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [id]: value,
    }));
    setValidationErrors((prev) => ({
      ...prev,
      [id]: false,
    }));
  };

  const fetchCashReceiptDetails = async () => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/CashReceipt/get_details_Virtual_Load_Cashreceipt_Sp/${userDetails.dcode}/${userDetails.srocode}/0/receipt_commision`
      );

      if (response.data.statusResponse.statusCode === 200) {
        setCashReceiptData(response.data.cashReceiptDetails);
        setEditMode(false);
      } else {
        setError("No data found");
      }
    } catch (err) {
      setError("Failed to fetch data");
    } finally {
      setLoading(false);
    }
  };
  const fetchUpdateCashReceiptDetails = async () => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/CashReceipt/GetReceiptModification/${userDetails.dcode}/${userDetails.srocode}/${vol}/${sr}/${regYear}`
      );

      setUpdateCashReceiptData(response.data[0]);
      setEditMode(true);
    } catch (err) {
      setError("Failed to fetch data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    debugger;
    if (typeRecpt === "Commission" && mod === true) {
      fetchUpdateCashReceiptDetails();
    } else {
      fetchCashReceiptDetails();
    }
  }, [typeRecpt, mod]); // Dependency array ensures this runs when typeRecpt changes
  useEffect(() => {
    if (editMode && updateCashReceiptDetails) {
      setFormData({
        prtname: updateCashReceiptDetails.appName || "",
        prt2name: updateCashReceiptDetails.appAdd || "",
        property_detail: updateCashReceiptDetails.comReason || "",
      });

      setFee(updateCashReceiptDetails.miscFee || "");
    }
  }, [updateCashReceiptDetails, editMode]);

  const CashReceiptReportLink = (printData) => {
    debugger;
    return `${REPORT_BASE_URL}/Report/CashReceiptReports.aspx?dcode=${
      userDetails.dcode
    }&srocode=${userDetails.srocode}&vol=${printData.vol}&sr=${
      printData.sr
    }&year=${
      printData.regYear
    }&recptDate=${currentDate}&tdate=${currentDate}&mode=receipt&mode1=${"commission"}`;
  };

  const handleSave = async () => {
    const errors = {};

    if (!formData.prtname) {
      errors.prtname = "Please fill Applicant Name";
    } else if (!formData.prt2name) {
      errors.prt2name = "Please fill Registration Details";
    } else if (!formData.property_detail) {
      errors.property_detail = "Please fill Reason of Commission";
    }

    // If there are errors, set validation state and show first error message
    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      toast.error(Object.values(errors)[0]); // Show only the first error
      return;
    }

    try {
      const formData2 = new FormData();

      const payload = {
        dcode: userDetails.dcode,
        srocode: userDetails.srocode,
        pimode: "receipt_commision",
        tokenno: 0,
        misc_fee: fee || 50,
        code: selectedYears,
        fyear: fromYear || 0,
        tyear: toYear || 0,
        nakalown: "string",
        nakalregdate: "",
        nakalcopy: "",
        mode: "string",
        prtname: formData.prtname,
        prt2name: formData.prt2name,
        property_detail: formData.property_detail,
      };

      Object.keys(payload).forEach((key) => {
        formData2.append(key, payload[key]);
      });
      console.log(formData2);
      const response = await axios.post(
        `${API_BASE_URL}/CashReceipt/Insert_Cashreceipt_Sp`,
        formData2,
        {
          headers: {
            "Content-Type": "application/json", // Set content type to application/json
          },
        }
      );
      if (response.status === 200 && response.data) {
        console.log("API Response:", response.data);
        const printData = response.data.response;
        fetchCashReceiptDetails();
        toast.success("Fees Submitted Successfully");
        setValidationErrors("");

        const reportUrl = CashReceiptReportLink(
          printData,
          new Date().toISOString().split("T")[0] // Format as YYYY-MM-DD
        );

        // Open report in a new tab
        window.open(reportUrl, "_blank");
        setFormData({
          prtname: "",
          prt2name: "",
          property_detail: "",
          s_party: "",
          f_party: "",
          deed: "",
          Regdate: "",
        });
      } else {
        throw new Error("Not found");
      }
    } catch (err) {
      console.error("Error in Insert Search Receipt API:", err);
      alert("Error occurred while saving the receipt.");
      toast.error("Contact IT Cell");
    }
  };

  const handleUpdate = async () => {
    const errors = {};

    if (!formData.prtname) {
      errors.prtname = "Please fill Applicant Name";
    } else if (!formData.prt2name) {
      errors.prt2name = "Please fill Registration Details";
    } else if (!formData.property_detail) {
      errors.property_detail = "Please fill Reason of Commission";
    }

    // If there are errors, set validation state and show first error message
    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      toast.error(Object.values(errors)[0]); // Show only the first error
      return;
    }
    debugger;
    try {
      const formData2 = new FormData();
      const payload = {
        dcode: userDetails.dcode,
        srocode: userDetails.srocode,
        pimode: "receipt_commision",
        tokenno: bookNo,
        prtname: formData.prtname,
        prt2name: formData.prt2name,
        misc_fee: fee || 100,
        code: selectedYears,
        property_detail: formData.property_detail,
        fyear: fromYear || 0,
        tyear: toYear || 0,
        nakalown: "string",
        nakalregdate: "string",
        nakalcopy: "0",
        mode: "string",
        vol: updateCashReceiptDetails?.vol || "",
        sr: updateCashReceiptDetails?.sr || "",
        epayment_rfee: updateCashReceiptDetails?.epayment_rfee || "",
      };

      Object.keys(payload).forEach((key) => {
        formData2.append(key, payload[key]);
      });

      const response = await axios.post(
        `${API_BASE_URL}/CashReceipt/Update_Cashreceipt_Sp`,
        formData2,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200 && response.data) {
        console.log("API Response:", response.data);
        const printData = response.data.response;
        fetchCashReceiptDetails();
        toast.success("Fees Submitted Successfully");

        // Generate the report URL
        const reportUrl = CashReceiptReportLink(
          printData,
          new Date().toISOString().split("T")[0] // Format as YYYY-MM-DD
        );

        // Open report in a new tab
        window.open(reportUrl, "_blank");
        navigate("/ModifyReciept");
      } else {
        throw new Error("Not found");
      }
    } catch (err) {
      console.error("Error in Update Search Receipt API:", err);
      alert("Error occurred while updating the receipt.");
    }
  };
  return (
    <div className="flex flex-col md:flex-row h-screen">
      <SideMenu className="w-full md:w-64" />
      <div className="flex-1 flex flex-col overflow-hidden">
        <div className="shadow-sm">
          <Header />
        </div>

        <div className="flex flex-1 flex-col md:flex-row overflow-y-auto">
          {/* Left Side */}
          <div className="flex-1 p-2 md:p-4">
            <div className="p-4 md:p-8 bg-gray-100 min-h-screen">
              <h1 className="text-xl md:text-2xl font-bold text-gray-800 mb-4">
                New Receipt - Commission
              </h1>

              <div className="bg-white p-4 md:p-6 space-y-4">
                {/* Date and Details Section */}
                <div className="flex flex-col space-y-4 md:space-y-0 md:flex-row md:items-center md:space-x-6">
                  <div>
                    <b>Date: </b>
                    <span>
                      {editMode
                        ? updateCashReceiptDetails.recptDate
                        : currentDate}
                    </span>
                  </div>
                  <div>
                    <b>Application no. </b>
                    <span>
                      {editMode
                        ? updateCashReceiptDetails.appliNo
                        : cashReceiptData.applino}
                    </span>
                  </div>
                  <div>
                    <b>Serial no: </b>
                    <span>
                      {editMode
                        ? updateCashReceiptDetails.sr
                        : cashReceiptData.sr}
                    </span>
                  </div>
                  <div>
                    <b>Vol no: </b>
                    <span>
                      {editMode
                        ? updateCashReceiptDetails.vol
                        : cashReceiptData.vol}
                    </span>
                  </div>
                  <div>
                    <b>Commission Fee: </b>
                    <span>
                      {editMode ? updateCashReceiptDetails.miscFee : fee}
                    </span>
                  </div>
                </div>

                {/* Text Inputs */}
                <div className="grid grid-cols-4 md:grid-cols-4 gap-4 mt-4">
                  <div className="col-span-2">
                    <div className="relative">
                      <input
                        id="prtname"
                        type="text"
                        value={formData.prtname}
                        onChange={handleChange}
                        className={`w-full border ${
                          validationErrors.prtname
                            ? "border-[#DA0000]"
                            : "border-[#B1B1B1]"
                        } p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 peer`}
                        placeholder=""
                      />
                      <label
                        htmlFor="prtname"
                        className="absolute text-sm text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1"
                      >
                        Applicant Name
                      </label>
                    </div>
                  </div>

                  <div className="col-span-2">
                    <div className="relative">
                      <input
                        id="prt2name"
                        type="text"
                        value={formData.prt2name}
                        onChange={handleChange}
                        className={`w-full border ${
                          validationErrors.prt2name
                            ? "border-[#DA0000]"
                            : "border-[#B1B1B1]"
                        } p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 peer`}
                        placeholder=""
                      />
                      <label
                        htmlFor="prt2name"
                        className="absolute text-sm text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1"
                      >
                        Registration Details (Dafa 60)
                      </label>
                    </div>
                  </div>

                  <div className="col-span-4">
                    <div className="relative">
                      <textarea
                        id="property_detail"
                        value={formData.property_detail}
                        onChange={handleChange}
                        placeholder=""
                        className={`w-full border ${
                          validationErrors.property_detail
                            ? "border-[#DA0000]"
                            : "border-[#B1B1B1]"
                        } p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 peer`}
                      />
                      <label
                        htmlFor="property_detail"
                        className="absolute text-sm text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1"
                      >
                        Reason of Commission
                      </label>
                    </div>
                  </div>

                  {/* Buttons */}
                  <div className="col-span-2 md:col-span-1 md:col-end-3">
                    <div className="relative">
                      <button
                        onClick={editMode ? handleUpdate : handleSave}
                        className="w-full bg-blue-400 text-white px-6 py-2 rounded hover:bg-blue-700 focus:outline-none"
                      >
                        {editMode ? "UPDATE" : "SAVE"}
                      </button>
                    </div>
                  </div>
                  <div className="col-span-2 md:col-span-1 md:col-end-4">
                    <div className="relative">
                      <button className="w-full text-[#DA0000] px-6 py-2 border border-[#DA0000] rounded hover:bg-red-100 focus:outline-none">
                        CANCEL
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Right Side - Hidden on mobile, visible on medium screens and above */}
          <div className="hidden md:block w-64 h-full">
            <UserMenu />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Commision;
